/*Questo modulo si occupa di recuperare le impostazione relative al duo del gateway*/
import Vue from "vue";
import {
  ApiService,
} from "@/common/api.service";

const initialState = {
  settings: null,
  loading: false
};

export const state = { ...initialState };

export const actions = {
  async fetch(context) {
    context.commit("setLoading", true);
    const { data } = await ApiService.get("audio");
    context.commit("setSettings", data);
    context.commit("setLoading", false);
    return data;
  },
  async saveSettings(context, settings) {
    await ApiService.post('audio', { request: "save", data: settings });
    //context.dispatch('fetchDuo');
  }
};


export const mutations = {

  setSettings(state, data) {
    state.settings = data;
    console.log('New settings: ', data);
  },
  setLoading(state, data) {
    state.loading = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
